module.exports = __webpack_public_path__ + "img/funding-new6.e408affc.png";